export function pluralise(count: number, singular: string, plural = `${singular}s`) {
  const word = count === 1 ? singular : plural;

  return `${count} ${word}`;
}
